import React, { useState } from 'react';
import { Modal, Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

const OuterModal = (props) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <Modal basic dimmer={props.dimmer} open={props.open} onClose={() => props.setOpen(false)} size="tiny">
            <Modal.Actions style={{ textAlign: "right" }}>

                <Icon
                    name="close icon"
                    size="large"
                    style={{
                        color: isHovered ? "red" : "white",
                        cursor: "pointer",
                        transition: "color 0.3s ease",
                    }}
                    onClick={() => props.setOpen(false)}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                </Icon>

            </Modal.Actions>
            <Modal.Header style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Icon name={props.icn} size="big" color={props.icnColor} />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div>

                    {props.msg}<br />

                    {props.msg2}
                </div>
            </Modal.Header>
        </Modal>
    );
};

export default OuterModal;
